import { createIconComponent } from '../../factory/create-icon-component';
export const ExcessIcon = createIconComponent(
  'ExcessIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 3V7.47M14.25 14.8101C17.3399 15.6693 19.0609 15.7921 21.95 14.8101M2.04968 17.0601C5.16167 18.0362 6.83954 17.9564 9.74968 17.0601M18.1027 7.5L14.4527 14.278C14.2397 14.673 14.1517 15.132 14.2377 15.572C14.5917 17.383 16.1877 18.75 18.1017 18.75C20.0157 18.75 21.6117 17.383 21.9657 15.572C22.0517 15.132 21.9637 14.673 21.7507 14.278L20.9997 12.5L19.4997 10L18.1027 7.5ZM18.1027 7.5C14.1567 6.773 10.0807 7.43609 6.56867 9.37809L5.89668 9.75M5.89668 9.75L2.24668 16.528C2.03368 16.923 1.94568 17.382 2.03168 17.822C2.38668 19.633 3.98168 21 5.89668 21C7.81168 21 9.40668 19.633 9.76068 17.822C9.84668 17.382 9.75868 16.923 9.54568 16.528L8.72307 15L7.49969 12.5L5.89668 9.75Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
